import axios from 'axios';
import { ROOT_URL } from './constants';

/**
 * Constante que representa la acción de obtener los usuarios de impersonación.
 * @type {string}
 */
export const GET_IMPERSONATION_USERS = 'GET_IMPERSONATION_USERS';

/**
 * Acción para obtener la lista de usuarios que pueden ser impersonados.
 * Realiza una petición al servidor para obtener los usuarios autorizados para impersonación.
 *
 * @export
 * @param {Function} [successCallback=() => {}] - Función a ejecutar cuando la petición es exitosa
 * @param {Function} [errorCallback=(error) => {}] - Función a ejecutar cuando ocurre un error
 * @returns {Function} Función asíncrona que despacha la acción con los usuarios obtenidos
 */
export function getImpersonationUsers(successCallback = () => {}, errorCallback = (error) => {}) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${ROOT_URL}/parameters/impersonation_users`);
      dispatch({
        type: GET_IMPERSONATION_USERS,
        payload: response.data
      });
      successCallback(response.data);
    } catch (error) {
      errorCallback(error);
    }
  };
} 